import { ReactSVG } from "react-svg";
import { ContactAddressRow } from "services/api/contacts/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/** Stupci adresa u čarobnjaku kontakta — isti izgled kao popis PP aparata na unosu vozila. */
export const CONTACT_EDIT_ADDRESS_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Adresa",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactAddressRow) => {
      return (
        <div>
          <div className="flex items-center gap-2">
            <span className="text-md font-medium text-slate-600">{row.line1}</span>
            {row.primary && <Badge text="Primarna" variant="info" height="small" />}
          </div>
          {row.line2 && <div className="text-xs text-slate-500">{row.line2}</div>}
        </div>
      );
    },
  },
  {
    title: "Mjesto",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactAddressRow) => {
      return (
        <div className="text-sm text-slate-900 truncate">
          {row.postalCode} {row.city}
        </div>
      );
    },
  },
  {
    title: "Država",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactAddressRow) => {
      return <div className="text-sm text-slate-900 truncate">{row.country}</div>;
    },
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactAddressRow) => {
      return (
        <div onClick={(e) => handleDeleteClick(e, row.id)} className="flex justify-end items-center h-[30px]">
          <ReactSVG src={"/media/icons/trash.svg"} className="w-4 h-4 stroke-[#bd0000]" />
        </div>
      );
    },
  },
];
